import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';

import { CalculatedWithdrawal } from './calculateWithdrawalValues';

export type CalculateCryptoWithdrawalValuesArgs = {
  amount: number;
  fireblocksId: string;
  walletAddress: string;
  amountInAssetCode: string;
  cryptoAssetCode: string;
  fiatAssetCode: string;
};

export type CalculateCryptoWithdrawalValuesResponse = {
  calculateCryptoWithdrawalValues: DefaultApiResponse<CalculatedWithdrawal>;
};

export const calculateCryptoWithdrawalValuesQuery: TypedDocumentNode<
  CalculateCryptoWithdrawalValuesResponse,
  DefaultArg<CalculateCryptoWithdrawalValuesArgs>
> = gql`
  query calculateCryptoWithdrawalValues(
    $record: CalculateCryptoWithdrawalValuesRecord!
  ) {
    calculateCryptoWithdrawalValues(record: $record) {
      fee
      remainingAmount
      totalAmount
      valueInGivenFiat
    }
  }
`;
